'use client';
import Image from 'next/image';

const galleryImages = [
  '/images/event-highlights/gallery-01.webp',
  '/images/event-highlights/gallery-02.webp',
  '/images/event-highlights/gallery-03.webp',
  '/images/event-highlights/gallery-04.webp',
  '/images/event-highlights/all-speakera.webp',
  // '/images/event-highlights/event-erik.webp',
  '/images/event-highlights/with-mic.webp',
  // '/images/event-highlights/speaking-speaker.webp',
  '/images/event-highlights/people-connection.webp',
  '/images/event-highlights/profestional-networking.webp',
  '/images/event-highlights/welcon-event.webp',
  '/images/event-highlights/networking.webp',
  '/images/event-highlights/event.webp',
  '/images/event-highlights/event-crowd.webp',
  

];

export default function GallerySection() {
  return (
<section data-component-id="src/app/GallerySection.tsx:25:0" data-component-path="src/app/GallerySection.tsx" data-component-line="25" data-component-file="GallerySection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22event-highlights%22%2C%22className%22%3A%22w-full%20bg-white%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%22%7D" id='event-highlights' className="w-full bg-white p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4"
    >      {/* Heading */}
      <h2 data-component-id="src/app/GallerySection.tsx:27:6" data-component-path="src/app/GallerySection.tsx" data-component-line="27" data-component-file="GallerySection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20mb-10%20text-%5B28px%5D%20sm%3Atext-%5B36px%5D%20md%3Atext-%5B46px%5D%20lg%3Atext-%5B56px%5D%20font-bold%20font-satoshi%20leading-tight%20bg-gradient-to-b%20from-black%20to-gray-500%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Event%20Highlights%22%7D" className="text-center mb-10 text-[28px] sm:text-[36px] md:text-[46px] lg:text-[56px] font-bold font-satoshi leading-tight bg-gradient-to-b from-black to-gray-500 bg-clip-text text-transparent">
          Event Highlights
        </h2>

      {/* Gallery Grid */}
      <div data-component-id="src/app/GallerySection.tsx:32:6" data-component-path="src/app/GallerySection.tsx" data-component-line="32" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20gap-3%20sm%3Agap-4%22%7D" className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
        {galleryImages.map((src, index) => (
          <div data-component-id="src/app/GallerySection.tsx:34:10" data-component-path="src/app/GallerySection.tsx" data-component-line="34" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-lg%22%7D"
            key={index}
            className="relative group overflow-hidden rounded-lg"
          >
            <Image data-component-id="src/app/GallerySection.tsx:38:12" data-component-path="src/app/GallerySection.tsx" data-component-line="38" data-component-file="GallerySection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20transition-transform%20duration-500%20group-hover%3Ascale-105%22%7D"
              src={src}
              alt={`Gallery ${index + 1}`}
              width={500}
              height={500}
              unoptimized
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />

            {/* Gradient Overlay */}
            <div data-component-id="src/app/GallerySection.tsx:48:12" data-component-path="src/app/GallerySection.tsx" data-component-line="48" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20group-hover%3Aopacity-0%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 group-hover:opacity-0 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
}
